//enabled features
import enabled_features from "./enabled_features";
//Features disabled on the panel
import disabled_features from "./disabled_features";
//Histogram Color
import studies_overrides from "./studies_overrides";
//Main configuration
import overrides from "./overrides";
//Set the initial loading bar style
import loading_screen from "./loading_screen";

export default {
  enabled_features,
  disabled_features,
  studies_overrides,
  overrides,
  loading_screen,
};
